import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";
import Styles from "./Code.module.scss";
import classNames from "classnames";

const BarcodeGenerator = ({ codes }) => {
  const svgRef1 = useRef();
  const svgRef2 = useRef();
  const svgRef3 = useRef();

  useEffect(() => {
    if (codes.length === 3) {
      JsBarcode(svgRef1.current, codes[0], {
        format: "CODE39",
        width: 1,
        height: 40,
        displayValue: true,
      });
      JsBarcode(svgRef2.current, codes[1], {
        format: "CODE39",
        width: 1,
        height: 40,
        displayValue: true,
      });
      JsBarcode(svgRef3.current, codes[2], {
        format: "CODE39",
        width: 1,
        height: 40,
        displayValue: true,
      });
    }
  }, [codes]);

  return (
    <div>
      <div className={classNames(Styles.code__barcode)}>
        <svg ref={svgRef1}></svg>
      </div>
      <div className={classNames(Styles.code__barcode)}>
        <svg ref={svgRef2}></svg>
      </div>
      <div className={classNames(Styles.code__barcode)}>
        <svg ref={svgRef3}></svg>
      </div>
    </div>
  );
};

export default BarcodeGenerator;
